/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Type_Niagaraboilerroom2Inputs */



/**
* | output |
* | --- |
* | "Niagara" |
*
* @param {Module_Type_Niagaraboilerroom2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const module_type_niagaraboilerroom2 = /** @type {((inputs?: Module_Type_Niagaraboilerroom2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Type_Niagaraboilerroom2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Niagara")
	return /** @type {LocalizedString} */ ("Niagara")
});
export { module_type_niagaraboilerroom2 as "module_type_niagaraBoilerRoom" }